import React from "react";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  label: string;
  value: string;
}

// 테두리 있는 label/value 칸 — 입금 계좌(은행·계좌번호·예금주)를 그리는 데 쓴다.
// 신청 모달과 입금 대기 요약 모달이 같은 계좌 3칸을 보여줘야 해서 한 곳에 모았다.
function MembershipInfoBox({ label, value }: Props) {
  return (
    <Flex
      flexDirection={"column"}
      gap={"2px"}
      padding={"12px"}
      border={"0.5px solid #D4D4D1"}
      borderRadius={"8px"}
    >
      <Text textStyle={"caption-medium"} color={"#8F8F8C"}>
        {label}
      </Text>
      <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
        {value}
      </Text>
    </Flex>
  );
}

export default MembershipInfoBox;
